<div class="p-grid img-container" style="padding: 15px;">
    <div class="p-grid" [class]="(cq === true || readonly === true)? 'p-col-7':'p-col-10'">

    </div>
    <div class="p-col-2">
        <div class="p-grid">
            <div class="p-col-12">
                <p-checkbox [binary]="true" [disabled]=" disableDoute() " [name]="douteName" [(ngModel)]="isDoute" label="Doute sur contenu" (onChange)="doute(isDoute)"></p-checkbox>
                <i class="pi pi-exclamation-triangle" *ngIf="isDoute" style="font-size: large; font-weight: bold; color: orangered; margin: 15px; float: right;"></i>
            </div>
        </div>
    </div>
    
    <div class="p-grid p-col-12">
        
        <div [class]="(cq === true || readonly === true) ? 'p-col-6' : 'p-col-9'">
            <div class="ui-inputgroup">
                <input type="text" pInputText [(ngModel)]="lien" style="width:100%" [disabled]="disabled" (ngModelChange)="linkChanged(lien)"/>
                <button pButton type="button" icon="pi pi-external-link" style="border-color: gainsboro; background-color: gainsboro;color: darkslategray;" (click)="openLinkOnNewTab()"></button>
                
                <ng-template [ngIf]="cq === false && readonly === false">
                    <button pButton type="button" icon="pi pi-pencil"  (click)="setEditable()" style="border-color: steelblue; background-color: steelblue;"></button>
                </ng-template>
            </div>
        </div>

        <div class="p-col-1">
            <div style="border-left:1px solid darkgrey;height:100%; width:0; margin:auto; border-width: medium;"></div>
        </div>

        <div class="p-col-2">
            <div class="p-grid">
                
            <!--  
                <div class="p-col-12" style="text-align: left;">
                    <h4>Contenu dupliqué</h4>
                    <div class="p-grid" style="width:100%;margin: auto">
                        <div class="p-col-6"><p-radioButton [disabled]="cq || readonly" [name]="duplicateName" [value]="true" label="Oui" [(ngModel)]="duplicate" inputId="id_duplicate"></p-radioButton></div>
                        <div class="p-col-6"><p-radioButton [disabled]="cq || readonly" [name]="duplicateName" [value]="false" label="Non" [(ngModel)]="duplicate" inputId="not_duplicate"></p-radioButton></div>
                    </div>
                </div>
            -->
            <!--    <ng-template [ngIf]="duplicate === false"> -->
                    <div class="p-col-12" style="text-align: left;">
                        <h4>Statut</h4>
                        <div class="p-grid" style="width:100%;margin: auto">
                            <div class="p-col-6"><p-radioButton [disabled]=" disableModeration() " [name]="validName" [value]="true" label="OK" [(ngModel)]="valid" (ngModelChange)="validChanged(valid)" inputId="is_valid"></p-radioButton></div>
                            <div class="p-col-6"><p-radioButton [disabled]=" disableModeration() " [name]="validName" [value]="false" label="KO" [(ngModel)]="valid" (ngModelChange)="validChanged(valid)" inputId="non_valid"></p-radioButton></div>
                        </div>
                    </div>
                    <ng-template [ngIf]="valid === false">
                        <div class="p-col-12" >
                            <app-erreurs [cq]="disableModeration()" [error-list]=" errors " [selected-errors]="selectedErrors" (errorsChangedEvent)="setErrors($event)"></app-erreurs>
                        </div>
                    </ng-template>

                    <ng-template [ngIf]="motifs.length > 0">
                        <div class="p-col-12">
                            <h4>Motif(s) :</h4>
                            <ul>
                                <li *ngFor="let motif of motifs">
                                    {{motif["designation_motif"]}}
                                </li>
                            </ul>
                        </div>
                    </ng-template>

                    <ng-template [ngIf]="motifsCq.length > 0 && cq === false">
                        <hr width="100%" style="display: block; height: 1px;border: 0; border-top: 1px solid #ccc; margin: 1em 0; padding: 0;">
                        <div class="p-col-12" style="font-weight: bold; color: tomato;">
                            <h4>Motif(s) KO CQ:</h4>
                            <ul>
                                <li *ngFor="let motif of motifsCq">
                                    {{motif["designation_motif"]}}
                                </li>
                            </ul>
                        </div>
                    </ng-template>
                    <ng-template [ngIf]="motifsCq.length === 0 && cq === false && validationCQ === false" >
                            <h4 style="font-weight: bold; color: tomato;text-align: center;width: 100%;">KO CQ : Décision non conforme</h4>
                    </ng-template>

            <!--    </ng-template> -->
                
            </div>
        </div>

        <ng-template [ngIf]="cq === true || readonly === true">
            <div class="p-col-1">
                <div style="border-left:1px solid darkgrey;height:100%; width:0; margin:auto; border-width: medium;"></div>
            </div>

            <div class="p-col-2">
                <div class="p-grid">
                    <div class="p-col-12" style="text-align: left;">
                        <h4>CQ</h4>
                        <div class="p-grid" style="width:100%;margin: auto">
                            <div class="p-col-6"><p-radioButton [disabled]="readonly" [name]="cqName" [value]="true" label="C" [(ngModel)]="validationCQ" inputId="is_valid" (ngModelChange)="validCqChanged(validationCQ)"></p-radioButton></div>
                            <div class="p-col-6"><p-radioButton [disabled]="readonly" [name]="cqName" [value]="false" label="NC" [(ngModel)]="validationCQ" inputId="non_valid" (ngModelChange)="validCqChanged(validationCQ)"></p-radioButton></div>
                        </div>
                    </div>
                    <ng-template [ngIf]="validationCQ === false">
                        <div class="p-col-12" >
                            <app-erreurs [cq]="readonly" [error-list]=" errors " (errorsChangedEvent)="setCqErrors($event)"></app-erreurs>
                        </div>
                    </ng-template>
                    <ng-template [ngIf]="motifsCq.length > 0">
                        <div class="p-col-12">
                            <h4>Sur les motifs :</h4>
                            <ul>
                                <li *ngFor="let motif of motifsCq">
                                    {{motif["designation_motif"]}}
                                </li>
                            </ul>
                        </div>
                    </ng-template>

                    
                </div>
            </div>
       </ng-template>
    
    </div>


    <!-- PARTIE ETATS ANTERIEURS-->
   <div class="p-col-12" style="margin-top: 15px;" *ngIf="ContenusAnterieurs.length > 0 && isRetour">
        <hr style="margin : 15px 15%;">
        <h2 style="text-align: center;">HISTORIQUE</h2>
        <div *ngFor="let current of ContenusAnterieurs" class="p-grid historique" style="margin-top: 15px;">
            <div class="p-col-12">
                <div class="p-grid">
                    <div class="p-col-2"> <strong> Type  : {{ current['designation_type_ptl'] }} </strong> </div> 
                    <div class="p-col-2"> <strong> Etape  : {{ (current['id_action'] === 5) ? 'CQ' : 'Modération' }} </strong> </div>
                    <div class="p-col-2"> <strong> Statut : {{ (current['id_action'] === 5) ? ( (current['is_valid_cq']) ? 'OK' : 'KO' ) : ( (current['is_valid']) ? 'OK' : 'KO' ) }}</strong> </div>
                    <div class="p-col-4"> <strong> Action effectuée le  : {{ current['date_action']  }} </strong> </div>
                </div>
            </div>
            <div class="p-col-9">
                <div class="ui-inputgroup">
                    <input type="text" pInputText [(ngModel)]=" current['valeur_contenu'] " style="width:100%" [disabled]="disabled"/>
                    <button pButton type="button" icon="pi pi-external-link" style="border-color: gainsboro; background-color: gainsboro;color: darkslategray;" (click)="openLinkOnNewTab(current['valeur_contenu'])"></button>
                </div>
            </div>
            <div class="p-col-3">

                <div style="width: 100%;" *ngIf="current['id_action'] === 2 && current['erreurs'].length > 0 ">
                    <ul>
                        <li *ngFor="let motif of current['erreurs'] ">
                                {{motif['designation_motif'] }}
                        </li>
                    </ul>
                </div>

                <div style="width: 100%;" *ngIf="current['id_action'] === 5 && current['erreurs_cq'].length > 0 ">
                    <ul>
                        <li *ngFor="let motif of current['erreurs_cq'] ">
                                {{motif['designation_motif'] }}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
<!-- FIN ETATS ANTERIEURS -->

    

</div>
